module.exports = __webpack_public_path__ + "img/ellipsis-stroke.5196beab.svg";